import { Button } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

function DomainSettingsHeader() {
    return (
        <div className="marketing-settings__header">
            <Button onClick={() => {}}>{getLiteral('create_new_domain')}</Button>
        </div>
    );
}

DomainSettingsHeader.displayName = 'DomainSettingsHeader';

export default DomainSettingsHeader;
